<template>
  <div class="wallet-option">
    <app-radio-button
      v-if="showRadio"
      :id="token"
      group-name="paymentOptions"
      :model-value="token"
      :payload="null"
      :disabled="!validExpDate()"
      @update:modelValue="$emit('update:modelValue', getCardData)"
    >
      <div class="d-flex flex-space-between">
        <div class="d-flex">
          <img class="radio-label__image" :src="require('@/assets/images/icon-new-credit-card.svg')" alt="" />
          <div class="card-info">
            <span>{{ getCardLabel() }}</span>
            <div v-if="expiration" class="info-container">
              <span v-if="cardHolder && validExpDate()" class="expiration-text">Exp {{ expiration }}</span>
              <span v-else class="expired-text"></span>
            </div>
          </div>
        </div>
      </div>
    </app-radio-button>
    <div v-else>
      <div class="d-flex flex-space-between">
        <div class="d-flex">
          <img :src="require('@/assets/images/icon-new-credit-card.svg')" alt="" />
          <div class="card-info">
            <span>{{ getCardLabel() }}</span>
            <div v-if="expiration" class="info-container">
              <span v-if="cardHolder && validExpDate()" class="expiration-text">Exp {{ expiration }}</span>
              <span v-else class="expired-text"></span>
            </div>
          </div>
        </div>
        <button v-if="showDelete" :id="`delete-${token}`" @click="deleteCard()">
          <img src="@/assets/images/delete-icon.svg" />
        </button>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import AppRadioButton from "../../../components/base/app-radio-button/AppRadioButton";
import { mapActions } from "vuex";
import { MODAL, showDialog } from "@/utils";
import { CAMPUS_ACCOUNT_MAP } from "@appetize/iw-common/constants";

export default {
  name: "UserCreditCard",
  components: {
    AppRadioButton
  },
  props: {
    cardHolder: String,
    lastFour: String,
    expiration: String,
    token: String,
    gatewayId: String,
    showRadio: Boolean,
    showDelete: Boolean
  },
  computed: {
    getCardData() {
      return {
        tokenCard: this.token,
        cardHolder: this.cardHolder,
        lastFour: this.lastFour,
        expDate: this.expiration,
        gatewayId: this.gatewayId
      };
    }
  },

  methods: {
    ...mapActions({
      deleteCreditCardToken: "user/deleteCreditCardToken"
    }),
    validExpDate: function () {
      if (!this.expiration) return true;
      let [month, year] = this.expiration?.split("/");
      const fullYear = 2000 + parseInt(year, 10);
      month = parseInt(month, 10);
      const expDate = new Date(fullYear, month, 0);
      return expDate > new Date();
    },
    getCardLabel() {
      const campusCard = CAMPUS_ACCOUNT_MAP[this.gatewayId]?.display;
      if (!this.cardHolder && !campusCard) return `**** **** **** ${this.lastFour}`;
      return `${campusCard ? `${campusCard} - ` : ""} ${this.cardHolder} - ${this.lastFour}`;
    },
    async deleteCard() {
      showDialog(
        this,
        "Delete Payment Method?",
        `Continuing will remove ${this.getCardLabel()} from your wallet`,
        [
          {
            title: "Delete",
            handler: async () => {
              this.$modal.hide(MODAL.dialogName);
              await this.deleteCreditCardToken({ gateway_id: this.gatewayId, token: this.token });
              this.$emit("cardDeleted");
            }
          }
        ],
        true,
        false
      );
    }
  }
};
</script>

<style scoped lang="scss">
.wallet-option {
  padding-bottom: 1.5rem;
  img {
    margin-right: 0.5rem;
    width: 1.5em;
    background-color: #fff;
    max-height: 36px;
  }

  .radio-label__image {
    margin-left: 36px;
  }

  .card-info {
    height: 20px;
    margin-top: 5px;
  }

  button {
    background: #fff;
    border: none;
    cursor: pointer;
  }

  .info-container {
    display: flex;
    span {
      display: block;
    }

    .expiration-text {
      color: #767676;
    }

    .expired-text {
      color: #ff0000;
    }
  }
}
</style>
